import { render, staticRenderFns } from "./CustomMultiSelect.vue?vue&type=template&id=71a8b0aa&scoped=true&"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js&"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultiSelect.vue?vue&type=style&index=0&id=71a8b0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8b0aa",
  null
  
)

export default component.exports